import React from "react";
import { Row } from "react-bootstrap";
import Card from "./card";
import "./maincard.css";
const maincard = (props) => (
  <div className="cardlist">
    <Row>
      <Card
        photo="/image/batch1intern/shaan_kumar.jpg"
        name="Shaan Kumar"
        pos="Content Writing"
        work="5"
        link="https://www.linkedin.com/mwlite/in/shaan-kumar-9840b8192"
        cllg="( IIT BHU )"
      />
      <Card
        photo="/image/batch1intern/md_zuhair.jpg"
        name="MD Zuhair"
        pos="Content Writing"
        work="5"
        link="https://www.linkedin.com/in/md-zuhair-6926591a5/"
        cllg="( IIT BHU )"
      />
      <Card
        photo="/image/batch1intern/poulami_ghosh.jpg"
        name="Poulami Ghosh"
        pos="Content Review"
        work="25+"
        link="https://www.linkedin.com/in/poulami-ghosh-9a3756166/"
        cllg=" St. Thomas college of engineering and technology "
      />
      <Card
        photo="/image/batch1intern/aatif_rashid.jpg"
        name="Aatif Rashid"
        pos="Content Writing"
        work="3"
        link="https://www.linkedin.com/in/aatif20"
        cllg="( Jamia Millia Islamia )"
      />
      <Card
        photo="/image/batch1intern/ravi_teja.jpg"
        name="Ravi Teja Chidurala"
        pos="Content Writing"
        work="6"
        link="https://www.linkedin.com/in/ravi-teja-chidurala-b59b4b186"
        cllg="( JNTUH College of Engineering Hyderabad )"
      />
      <Card
        photo="/image/batch1intern/parak_singh.jpg"
        name="Parakh Pratap Singh"
        pos="Content Writing"
        work="4"
        link="https://www.linkedin.com/in/parakh-singh-6321b617b"
        cllg=" RV College Of Engineering "
      />
      <Card
        photo="/image/batch1intern/adarsh_agrawal.jpg"
        name="Adarsh Agrawal"
        pos="Content Writing"
        work="6"
        link="https://www.linkedin.com/in/adarsh-agrawal-620ab6148/"
        cllg="( IIT Roorke )"
      />

      <Card
        photo="/image/batch1intern/sanchit_kumawat.jpg"
        name="Sanchit Kumawat"
        pos="Content Writing"
        work="6"
        link="https://www.linkedin.com/in/sanchit-kumawat-14099464"
        cllg="( VIT )"
      />
      <Card
        photo="/image/batch1intern/satwik_kt.jpg"
        name="Satwik Tiwari"
        pos="Content Writing"
        work="6"
        link="https://codeforces.com/profile/Satwik_Tiwari"
        cllg="( IIIT Delhi )"
      />
      <Card
        photo="/image/batch1intern/tanmay_garg.jpg"
        name="Tanmay Garg"
        pos="Content Writing"
        work="6"
        link="https://www.linkedin.com/in/tanmay-garg-073a201a6"
        cllg="( Delhi Technological University )"
      />

      <Card
        photo="/image/batch1intern/adhish_kancharla.jpg"
        name="Adhish Kancharla"
        pos="Content Writing"
        work="2"
        link="#"
        cllg="( Bombay Scottish School )"
      />
      <Card
        photo="/image/batch1intern/shubham.jpg"
        name="Shubham Kumar"
        pos="Content Writing"
        work="6"
        link="https://www.linkedin.com/in/shubham-kumar-3590511a4"
        cllg="( IIT Kharagpur )"
      />
      <Card
        photo="/image/batch1intern/rishabh_roshan.jpg"
        name="Rishabh Roshan"
        pos="Content Writing"
        work="6"
        link="https://www.linkedin.com/in/rishabh-roshan"
        cllg=" CHANDIGARH UNIVERSITY "
      />
      <Card
        photo="/image/batch1intern/anuragdwivedi.jpg"
        name="Anurag Dwivedi"
        pos="Content Writing"
        work="6"
        link="https://www.linkedin.com/in/anurag-dwivedi-615231139/"
        cllg="( Dr. Ambedkar Institute of Technology )"
      />
    </Row>
  </div>
);

export default maincard;
